module.exports = __webpack_public_path__ + "img/hovered-layer5.599cf323.png";